import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, normalizeClass as _normalizeClass, mergeProps as _mergeProps, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "headline font-weight-bold primary--text"
}
const _hoisted_2 = {
  key: 0,
  class: "overline mt-2"
}
const _hoisted_3 = {
  key: 1,
  class: "text-left pb-0"
}
const _hoisted_4 = {
  key: 2,
  class: "overline mt-2"
}
const _hoisted_5 = {
  key: 3,
  class: "overline mt-2"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "white--text" }
const _hoisted_8 = {
  key: 0,
  class: "grey--text"
}
const _hoisted_9 = {
  key: 0,
  class: "grey--text"
}
const _hoisted_10 = {
  key: 0,
  class: "title mt-2"
}
const _hoisted_11 = {
  key: 1,
  class: "title mt-2"
}
const _hoisted_12 = {
  key: 2,
  class: "title mt-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_bar_chart = _resolveComponent("bar-chart")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_timeline_item = _resolveComponent("v-timeline-item")!
  const _component_v_hover = _resolveComponent("v-hover")!
  const _component_v_timeline = _resolveComponent("v-timeline")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_oss_mini_card = _resolveComponent("oss-mini-card")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!

  return (_openBlock(), _createBlock(_component_v_row, { "no-gutters": "" }, {
    default: _withCtx(() => [
      (_ctx.isAuthorized)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_v_col, {
              cols: "12",
              class: "d-flex py-2 px-6"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_switch, {
                  modelValue: _ctx.addEvenIfNone,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.addEvenIfNone) = $event)),
                  label: 'Tous les contrôles',
                  style: {}
                }, null, 8, ["modelValue"]),
                (_ctx.currentUser.allAvailableCompanies.length > 1)
                  ? (_openBlock(), _createBlock(_component_v_switch, {
                      key: 0,
                      modelValue: _ctx.allCompanies,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.allCompanies) = $event)),
                      label: 'Toutes les sociétés',
                      style: {},
                      class: "ml-2"
                    }, null, 8, ["modelValue"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_switch, {
                  modelValue: _ctx.isIgnored,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isIgnored) = $event)),
                  label: 'Filtrer les alertes ignorés',
                  style: {},
                  class: "ml-2"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_spacer),
                (!_ctx.$vuetify.display.mobile)
                  ? (_openBlock(), _createBlock(_component_v_btn_toggle, {
                      key: 1,
                      modelValue: _ctx.switchViewType,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.switchViewType) = $event)),
                      group: "",
                      mandatory: "",
                      color: "secondary",
                      density: "compact"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          "data-cy": "auditStatus-view-list",
                          icon: "$list",
                          value: 0
                        }),
                        _createVNode(_component_v_btn, {
                          "data-cy": "auditStatus-view-grid",
                          icon: "$grid_view",
                          value: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "12",
              class: _normalizeClass(!_ctx.$vuetify.display.mobile ? 'py-0' : 'px-2')
            }, {
              default: _withCtx(() => [
                (_ctx.viewType === 0)
                  ? (_openBlock(), _createBlock(_component_v_timeline, {
                      key: 0,
                      "align-top": "",
                      dense: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.checks, (check, i) => {
                          return (_openBlock(), _createBlock(_component_v_hover, { key: i }, {
                            default: _withCtx(({ isHovering, props }) => [
                              _createVNode(_component_v_timeline_item, _mergeProps({
                                color: _ctx.checkColor(check),
                                icon: _ctx.checkIcon(check),
                                ref_for: true
                              }, props), {
                                default: _withCtx(() => [
                                  (check.type === 'header')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.$t("audit.scope." + check.scope + ".title")), 1))
                                    : (_openBlock(), _createBlock(_component_v_row, {
                                        key: 1,
                                        justify: "space-between",
                                        class: _normalizeClass(_ctx.getTimeLineItemRowClass(check, isHovering))
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, { class: "pr-0 text-left py-0" }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", {
                                                class: "title",
                                                style: _normalizeStyle(_ctx.titleColor(check))
                                              }, [
                                                _createElementVNode("strong", null, _toDisplayString(check.count), 1),
                                                _createElementVNode("span", null, _toDisplayString(" " + check.title), 1)
                                              ], 4),
                                              (check.amountInfo)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(check.amountInfo), 1))
                                                : (check.check === 'CheckTax')
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.formatDate(check.dueDate) + " - " + check.text), 1))
                                                  : (check.addDescription)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t("audit." + check.check + ".description")), 1))
                                                    : (check.description)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(check.description), 1))
                                                      : _createCommentVNode("", true)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_v_col, {
                                            cols: "4",
                                            class: "pl-2 pr-0 py-0"
                                          }, {
                                            default: _withCtx(() => [
                                              (
                                            check.check === 'CheckDocSalesToReconciliate' &&
                                            check.followUpSales
                                        )
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                                    _createVNode(_component_bar_chart, {
                                                      data: check.followUpSales,
                                                      options: _ctx.followUpSalesOptions,
                                                      height: 80
                                                    }, null, 8, ["data", "options"])
                                                  ]))
                                                : (check.percentage !== undefined)
                                                  ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                                                      key: 1,
                                                      rounded: "",
                                                      height: 25,
                                                      color: "#5FC9B8",
                                                      "model-value": check.percentage
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("strong", _hoisted_7, _toDisplayString(check.percentage) + "%", 1)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["model-value"]))
                                                  : _createCommentVNode("", true)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_v_col, {
                                            cols: "1",
                                            class: "text-center pl-2 py-0"
                                          }, {
                                            default: _withCtx(() => [
                                              (check.show)
                                                ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                                                    key: 0,
                                                    icon: "$remove_red_eye",
                                                    color: "secondary",
                                                    onClick: _withModifiers(($event: any) => (_ctx.showItems(check)), ["stop"]),
                                                    "data-cy": 'auditStatus-show-' + check.check
                                                  }, null, 8, ["onClick", "data-cy"]))
                                                : _createCommentVNode("", true),
                                              (check.action)
                                                ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                                                    key: 1,
                                                    icon: "$spellcheck",
                                                    color: "secondary",
                                                    onClick: _withModifiers(($event: any) => (_ctx.openAction(check)), ["stop"]),
                                                    "data-cy": 'auditStatus-action-' + check.check
                                                  }, null, 8, ["onClick", "data-cy"]))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1032, ["class"]))
                                ]),
                                _: 2
                              }, 1040, ["color", "icon"])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.viewType === 1)
                  ? (_openBlock(), _createBlock(_component_v_expansion_panels, {
                      key: 1,
                      focusable: "",
                      accordion: "",
                      style: {"position":"inherit"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typedChecks, (type, cti) => {
                          return (_openBlock(), _createBlock(_component_v_expansion_panel, {
                            key: cti,
                            style: {"background":"transparent"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_expansion_panel_title, { class: "primary--text" }, {
                                default: _withCtx(({ open }) => [
                                  _createVNode(_component_v_row, {
                                    align: "center",
                                    class: "spacer",
                                    "no-gutters": "",
                                    "data-cy": 'auditStatus-scope-' + type.scope
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, null, {
                                        default: _withCtx(() => [
                                          _createElementVNode("strong", null, _toDisplayString(_ctx.$t("audit.scope." + type.scope + ".title")), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      (!open)
                                        ? (_openBlock(), _createBlock(_component_v_col, {
                                            key: 0,
                                            cols: "1",
                                            class: "text-center"
                                          }, {
                                            default: _withCtx(() => [
                                              (type.count)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_8, " (" + _toDisplayString(type.count) + ")", 1))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 2
                                          }, 1024))
                                        : _createCommentVNode("", true),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allStatus, (status, si) => {
                                        return (_openBlock(), _createBlock(_component_v_col, {
                                          key: si,
                                          class: "text-left"
                                        }, {
                                          default: _withCtx(() => [
                                            (!open)
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                  _createVNode(_component_v_icon, {
                                                    color: _ctx.checkColor(type[status])
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(_ctx.checkIcon(type[status])), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["color"]),
                                                  (type[status] && type[status].count)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, " (" + _toDisplayString(type[status].count) + ")", 1))
                                                    : _createCommentVNode("", true)
                                                ], 64))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1032, ["data-cy"])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_expansion_panel_text, { style: {"background":"transparent"} }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(type.checks, (check, ci) => {
                                        return (_openBlock(), _createBlock(_component_v_col, {
                                          cols: "4",
                                          key: ci
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_oss_mini_card, {
                                              title: check.title,
                                              "count-title": check.count,
                                              progress: 
                                            !check.followUpSales ? check.percentage : undefined
                                        ,
                                              "icon-btn1": check.show ? 'remove_red_eye' : null,
                                              "icon-btn2": check.action ? '$fa-spell-check' : null,
                                              "icon-notif": _ctx.checkIcon(check),
                                              "color-notif": _ctx.checkColor(check),
                                              "cy-prefix": 'auditStatus-' + check.check,
                                              style: {"height":"100%, background: #FFF !important"},
                                              "onClick:btn1": ($event: any) => (_ctx.showItems(check)),
                                              "onClick:btn2": ($event: any) => (_ctx.openAction(check))
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_col, {
                                                      class: "d-flex justify-center",
                                                      style: {"min-height":"52px"}
                                                    }, {
                                                      default: _withCtx(() => [
                                                        (check.check === 'CheckVATDeclaration')
                                                          ? (_openBlock(), _createBlock(_component_v_row, {
                                                              key: 0,
                                                              "no-gutters": ""
                                                            }, {
                                                              default: _withCtx(() => [
                                                                (check.amountInfo)
                                                                  ? (_openBlock(), _createBlock(_component_v_col, {
                                                                      key: 0,
                                                                      cols: "12",
                                                                      class: "title mt-2 text-center"
                                                                    }, {
                                                                      default: _withCtx(() => [
                                                                        _createTextVNode(_toDisplayString(check.amountInfo), 1)
                                                                      ]),
                                                                      _: 2
                                                                    }, 1024))
                                                                  : _createCommentVNode("", true),
                                                                (check.vatDeclarationDateRange)
                                                                  ? (_openBlock(), _createBlock(_component_v_col, {
                                                                      key: 1,
                                                                      cols: "12",
                                                                      class: "text-center"
                                                                    }, {
                                                                      default: _withCtx(() => [
                                                                        _createTextVNode(" A réaliser entre le " + _toDisplayString(_ctx.formatDate(
                                                                    check.vatDeclarationDateRange
                                                                        .start,
                                                                ) +
                                                                " et le " +
                                                                _ctx.formatDate(
                                                                    check.vatDeclarationDateRange
                                                                        .end,
                                                                )), 1)
                                                                      ]),
                                                                      _: 2
                                                                    }, 1024))
                                                                  : _createCommentVNode("", true)
                                                              ]),
                                                              _: 2
                                                            }, 1024))
                                                          : (check.check === 'CheckTax')
                                                            ? (_openBlock(), _createBlock(_component_v_row, {
                                                                key: 1,
                                                                "no-gutters": ""
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  (check.text)
                                                                    ? (_openBlock(), _createBlock(_component_v_col, {
                                                                        key: 0,
                                                                        cols: "12",
                                                                        class: "title mt-2 text-center"
                                                                      }, {
                                                                        default: _withCtx(() => [
                                                                          _createTextVNode(_toDisplayString(check.text), 1)
                                                                        ]),
                                                                        _: 2
                                                                      }, 1024))
                                                                    : _createCommentVNode("", true),
                                                                  (check.dueDate)
                                                                    ? (_openBlock(), _createBlock(_component_v_col, {
                                                                        key: 1,
                                                                        cols: "12",
                                                                        class: "text-center"
                                                                      }, {
                                                                        default: _withCtx(() => [
                                                                          _createTextVNode(" A payer avant le " + _toDisplayString(_ctx.formatDate(check.dueDate)), 1)
                                                                        ]),
                                                                        _: 2
                                                                      }, 1024))
                                                                    : _createCommentVNode("", true)
                                                                ]),
                                                                _: 2
                                                              }, 1024))
                                                            : (
                                                        check.check ===
                                                        'CheckDocSalesToReconciliate'
                                                    )
                                                              ? (_openBlock(), _createBlock(_component_v_row, {
                                                                  key: 2,
                                                                  "no-gutters": ""
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    (check.amountInfo)
                                                                      ? (_openBlock(), _createBlock(_component_v_col, {
                                                                          key: 0,
                                                                          cols: "12",
                                                                          class: "title mt-2"
                                                                        }, {
                                                                          default: _withCtx(() => [
                                                                            _createTextVNode(_toDisplayString(check.amountInfo), 1)
                                                                          ]),
                                                                          _: 2
                                                                        }, 1024))
                                                                      : _createCommentVNode("", true),
                                                                    (check.followUpSales)
                                                                      ? (_openBlock(), _createBlock(_component_v_col, {
                                                                          key: 1,
                                                                          cols: "12",
                                                                          class: "text-center pb-0",
                                                                          style: _normalizeStyle(
                                                                !_ctx.$vuetify.display.mobile
                                                                    ? 'min-height: 60px;'
                                                                    : ''
                                                            )
                                                                        }, {
                                                                          default: _withCtx(() => [
                                                                            _createVNode(_component_bar_chart, {
                                                                              data: check.followUpSales,
                                                                              options: _ctx.followUpSalesOptions,
                                                                              height: 80
                                                                            }, null, 8, ["data", "options"])
                                                                          ]),
                                                                          _: 2
                                                                        }, 1032, ["style"]))
                                                                      : _createCommentVNode("", true)
                                                                  ]),
                                                                  _: 2
                                                                }, 1024))
                                                              : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                                                  (check.amountInfo)
                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(check.amountInfo), 1))
                                                                    : (check.addDescription)
                                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.$t(
                                                                "audit." +
                                                                    check.check +
                                                                    ".description",
                                                            )), 1))
                                                                      : (check.description)
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(check.description), 1))
                                                                        : _createCommentVNode("", true)
                                                                ], 64))
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1032, ["title", "count-title", "progress", "icon-btn1", "icon-btn2", "icon-notif", "color-notif", "cy-prefix", "onClick:btn1", "onClick:btn2"])
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["class"])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}